import { DateSubscriptionFormik } from "../../../renters/components/forms/fields/DateSubscriptionFormik";
import { createAsaasFine, getVehicleById } from "../../../../common/services/vehicles.api";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import SlideToggle from "../../../../common/components/ui/toggleSwitch/SlideToggle";
import TextAreaFormik from "../../../../common/components/form/TextAreaFormik";
import { maskCPF, maskCurrency } from "../../../../common/helpers/mask.helpers";
import InputFormik from "../../../../common/components/form/InputFormik";
import { FineDocumentsRow } from "./componenets/FineVehicleDocumentRow";
import { isCPF } from "../../../../common/helpers/is-cpf";
import { IVehicle } from "../../../../types/vehicle.type";
import { useCallback, useEffect, useState } from "react";
import { FormikProvider, useFormik } from "formik";
import { Modal } from "flowbite-react";
import { format } from 'date-fns';
import * as Yup from "yup";


const validationSchema = Yup.object({
  renterCpf: Yup.string()
    .required('CPF é obrigatório!')
    .test('valida-cpf', 'CPF inválido ou incompleto!', value => isCPF(value)),
  subscriptionInitialDate: Yup.date()
    .required('A data de subscrição é obrigatória')
    .min(new Date(), 'A data não pode ser a de hoje'),
  isRealDriverFeeChecked: Yup.boolean()
});


type Props = {
  vehicle: { _id: string, licensePlate: string }
  onClose: () => void
}


export function ModalFinePayment(props: Props) {
  const [vehicleData, setVehicleData] = useState<IVehicle | null>(null)
  const { notifySuccess, notifyError } = useToastContext();

  const subscriptionInitialDate = format(new Date(), 'yyyy-MM-dd');
  const [isRealDriverFeeChecked, setIsRealDriverFeeChecked] = useState(false);

  useEffect(() => {
    async function loadVehicleData(vehicleId: string) {
      if (!vehicleId) return;

      const { data, ok } = await getVehicleById(vehicleId)
      if (ok) {
        setVehicleData(data as unknown as IVehicle)
      }
    }

    setVehicleData(null)

    if (props.vehicle._id) loadVehicleData(props.vehicle._id)

  }, [props.vehicle._id])

  const formik = useFormik({
    initialValues: {
      vehicleId: props.vehicle._id,
      renterCpf: '',
      reference: 'fine',
      fines: [{ value: '', infractionNumber: '', description: `PLACA: ${props.vehicle.licensePlate} - REFERENTE AO AUTO DE INFRAÇÃO Nº:` }],
      subscriptionInitialDate,
      isRealDriverFeeChecked: isRealDriverFeeChecked
    },
    validationSchema,
    onSubmit: async (data) => {

      const activationData = {
        ...data,
      };

      const result = await createAsaasFine(activationData)
      if (!result.ok) {
        notifyError(result.message as string)
        return
      }

      notifySuccess("Cobranças no Assas geradas com sucesso!")
    }
  })

  const handleAddField = useCallback(() => {
    const newField = {
      value: '',
      infractionNumber: '',
      description: `PLACA: ${props.vehicle.licensePlate} - REFERENTE AO AUTO DE INFRAÇÃO Nº:`
    };
    formik.setFieldValue('fines', [...formik.values.fines, newField]);
  }, [formik, props.vehicle.licensePlate]);

  const handleDeleteField = useCallback((index) => {
    // Copia o array atual de multas
    const newFines = [...formik.values.fines];

    // Remove o elemento no índice especificado
    newFines.splice(index, 1);

    // Atualiza o estado do Formik com o novo array
    formik.setFieldValue('fines', newFines);
  }, [formik]);

  const getFirstError = (errors) => {
    for (const errorKey in errors) {
      if (errors[errorKey]) {
        return errors[errorKey];
      }
    }
    return ''; // Retorna uma string vazia se não houver erros
  };

  const handleInfractionNumberChange = useCallback((index, event) => {
    const newInfractionNumber = event.target.value;
    // Atualiza o número da infração
    formik.setFieldValue(`fines[${index}].infractionNumber`, newInfractionNumber);
    // Atualiza a descrição dinamicamente com o novo número da infração
    const newDescription = `PLACA: ${props.vehicle.licensePlate} - REFERENTE AO AUTO DE INFRAÇÃO Nº: ${newInfractionNumber}`;
    formik.setFieldValue(`fines[${index}].description`, newDescription);
  }, [formik, props.vehicle.licensePlate]);


  return (
    <Modal
      className="text-black dark:text-black"
      show={true}
      onClose={() => props.onClose()}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header>
            <h2 className="dark:text-black">Gerar multa para a placa  {props.vehicle.licensePlate}</h2>
          </Modal.Header>
          <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(100vh - 300px)', height: 'calc(100vh - 300px)' }}>
            <InputFormik
              className="mt-2"
              name="renterCpf"
              label="Digite o CPF do locatário"
              mask={maskCPF}
              required={true}
              value={formik.values.renterCpf}
              onChange={formik.handleChange}
            />
            {/* 
            <InputFormik
              className="mt-2"
              name="depositInstallments"
              label="Digite o valor da multa"
              required={true}
              onChange={handleDepositChange}
              mask={maskCurrency}
            /> */}

            <div className="mt-2" style={{ display: 'flex', alignItems: 'center' }}>
              <label className="font-semibold text-[14px]">Adicionar taxa de real condutor?</label>
              <SlideToggle
                name="isCheckedRetraction"
                className="ml-2"
                onToggle={(checked) => {
                  setIsRealDriverFeeChecked(checked);
                  formik.setFieldValue("isRealDriverFeeChecked", checked);
                }}
              />
              <span style={{ marginLeft: '10px' }}>{isRealDriverFeeChecked ? "Sim" : "Não"}</span>
            </div>
            {isRealDriverFeeChecked && (
              <p className="text-redPrimary text-sm">O valor a ser adicionado à multa será de R$ 70,00</p>
            )}
            <div className="flex flex-col gap-1 mt-2">
              {formik.values.fines.map((_, index) => (
                <div key={index} className={`flex flex-col my-4 p-4 rounded ${index % 2 ? 'bg-gray/15' : 'bg-gray/25'}`}>
                  <InputFormik
                    name={`fines[${index}].value`}
                    label="Digite o valor da multa"
                    required={true}
                    onChange={formik.handleChange}
                    mask={maskCurrency}
                  />

                  <InputFormik
                    name={`fines[${index}].infractionNumber`}
                    label="Digite o número do auto de infração"
                    required={true}
                    value={formik.values.fines[index].infractionNumber}
                    onChange={event => handleInfractionNumberChange(index, event)}

                  />

                  <TextAreaFormik
                    name={`fines[${index}].description`}
                    value={formik.values.fines[index].description}
                    label='Descrição da multa de trânsito'
                    placeholder="Descrição"
                    onChange={formik.handleChange}
                    className='mt-4 flex-1'
                  />
                  {formik.values.fines.length > 1 && (
                    <div className='flex justify-end'>
                      <button
                        className='rounded-md text-white bg-redPrimary hover:text-white hover:bg-redPrimary/80 h-12 w-24 flex justify-center items-center'
                        type="button"
                        onClick={() => handleDeleteField(index)}
                      >
                        Remover
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className='flex justify-center'>
              <button
                type="button"
                className="mt-4 pb-12 items-center h-12 rounded-md text-black"
                onClick={handleAddField}
              >
                + Adicionar Campo
              </button>
            </div>

            <div>
              <DateSubscriptionFormik />
            </div>

            <div className="mt-2">
              {vehicleData && vehicleData.fineUpload && (
                <FineDocumentsRow vehicleId={props.vehicle._id} currentPath={vehicleData?.fineUpload as string[]} />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="felx  justify-end h-16 pb-8">
            <ButtonWithLoader
              isLoading={formik.isSubmitting}
              onClick={formik.handleSubmit}
              disabled={!formik.isValid}
            >
              Gerar
            </ButtonWithLoader>
            {formik.errors && <p className="text-redPrimary mt-2">{getFirstError(formik.errors)}</p>}
          </Modal.Footer>
        </FormikProvider>
      </form>
    </Modal >
  );
}